import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Presence, Skeleton, Stack } from '@chakra-ui/react';
import { PaymentElement } from '@stripe/react-stripe-js';
import { useState } from 'react';
const FormSkeletonRow = () => _jsx(Skeleton, { height: "50px" });
const FormSkeleton = () => (_jsxs(Stack, { gap: 3, children: [_jsx(FormSkeletonRow, {}), _jsx(FormSkeletonRow, {}), _jsx(FormSkeletonRow, {})] }));
export const CheckoutPaymentForm = ({ disabled }) => {
    const [ready, setReady] = useState(false);
    return (_jsxs(Box, { position: "relative", children: [_jsx(Presence, { present: !ready, children: _jsx(FormSkeleton, {}) }), _jsxs(Box, { visibility: ready ? 'visible' : 'hidden', opacity: disabled ? 0.5 : 1, transition: "opacity 0.2s", children: [_jsx(PaymentElement, { options: {
                            layout: 'tabs',
                            readOnly: disabled,
                            wallets: { applePay: 'never', googlePay: 'never' },
                        }, onReady: () => setReady(true) }), disabled && (_jsx(Box, { position: "absolute", inset: 0, cursor: "not-allowed" }))] })] }));
};
